export default __webpack_public_path__ + "static/dotnet-feb16dcd34f58d1f63f7d22970a6621b.png";